/**
 * MitEvida API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

import { CustomerInstallationConsumptionsResponse } from '../model/models';
import { ValidationErrorResponse } from '../model/models';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';



@Injectable({
  providedIn: 'root'
})
export class RegisteredConsumptionService {

    protected basePath = 'http://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }



    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key,
                        (value as Date).toISOString().substr(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * @param count 
     * @param customerNumber 
     * @param installationNumber 
     * @param continuationToken The token previously received in a MitEvida.BFF.REST.Features.Consumption.Registered.API.Models.CustomerInstallationConsumptionsResponse. Will allow the API to continue to fetch the next element. Should be null if you wish to receive the first items.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiConsumptionRegisteredCustomerCustomerNumberInstallationInstallationNumberGet(count: number, customerNumber: string, installationNumber: string, continuationToken?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<CustomerInstallationConsumptionsResponse>;
    public apiConsumptionRegisteredCustomerCustomerNumberInstallationInstallationNumberGet(count: number, customerNumber: string, installationNumber: string, continuationToken?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<CustomerInstallationConsumptionsResponse>>;
    public apiConsumptionRegisteredCustomerCustomerNumberInstallationInstallationNumberGet(count: number, customerNumber: string, installationNumber: string, continuationToken?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<CustomerInstallationConsumptionsResponse>>;
    public apiConsumptionRegisteredCustomerCustomerNumberInstallationInstallationNumberGet(count: number, customerNumber: string, installationNumber: string, continuationToken?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (count === null || count === undefined) {
            throw new Error('Required parameter count was null or undefined when calling apiConsumptionRegisteredCustomerCustomerNumberInstallationInstallationNumberGet.');
        }
        if (customerNumber === null || customerNumber === undefined) {
            throw new Error('Required parameter customerNumber was null or undefined when calling apiConsumptionRegisteredCustomerCustomerNumberInstallationInstallationNumberGet.');
        }
        if (installationNumber === null || installationNumber === undefined) {
            throw new Error('Required parameter installationNumber was null or undefined when calling apiConsumptionRegisteredCustomerCustomerNumberInstallationInstallationNumberGet.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (count !== undefined && count !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>count, 'Count');
        }
        if (continuationToken !== undefined && continuationToken !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>continuationToken, 'ContinuationToken');
        }

        let headers = this.defaultHeaders;

        // authentication (idm) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<CustomerInstallationConsumptionsResponse>(`${this.configuration.basePath}/api/consumption/registered/customer/${encodeURIComponent(String(customerNumber))}/installation/${encodeURIComponent(String(installationNumber))}`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
